
import { useNavigate } from "react-router-dom";
import { DownloadResponseDTO } from "../../openapi-generated-client";
import { formatDateWithoutYear, formatTime } from "../../utils/dateUtils";
import Table from "../table";
import { TableElementProps } from "../tableElement";
import { useSafeNavigate } from "../unloadBlocker";
import "./pieceInfoTable.css";

interface PieceInfoTableProps {
    data: DownloadResponseDTO[];
}

export default function PieceInfoTable(props: PieceInfoTableProps) {

    const navigate = useSafeNavigate(useNavigate());

    return <Table
        className="piece-info-table"
        titles={["Date", "Piece", "Composer", "Price"]}
        elementSwitch={[0, 1, 3, 2]}
        elements={props.data.flatMap((e, i) => {
            var prev;
            if(i > 0) {
                prev = props.data[i-1];
            }

            var date = new Date(e.date);

            var year = date.getFullYear();
            if(prev && new Date(prev.date).getFullYear() == year) {
                year = 0;
            }
            var day = formatDateWithoutYear(date);
            if(prev && day == formatDateWithoutYear(new Date(prev.date))) {
                day = "";
            }
            return [
                {
                    className: "date",
                    value: <>
                        <hr className={year == 0 ? "minus-year" : ""}/>
                        <span className="no-style">{year ? year : ""}</span>
                        <span className="no-style">{day}</span>
                        <span className="no-style">{formatTime(date)}</span>
                    </>
                },
                {
                    className: "hover",
                    onClick: () => {
                        navigate("/pieces/" + e.pieceId);
                    },
                    value: e.pieceTitle
                },
                {
                    className: "hover",
                    blue: true,
                    onClick: () => {
                        navigate("/artists/" + e.composerId);
                    },
                    value: e.composerName
                },
                {
                    blue: true,
                    value: e.price
                }
            ];
        }) as TableElementProps[]}
    />;

}